module.exports = __webpack_public_path__ + "static/rooftop_bg-e7935ea6dcb0dd29c4c58041d7186113.jpg";